export const searchInterpretMock = {
  parameters: {
    article_type: null,
    concepts: [],
    content_types: ["ARTICLE", "BUNDLE", "INTERACTIVE_VIDEO", "WORKSHEET"],
    grade_levels: [],
    instructional_features: [],
    needle: null,
    languages: [],
    maximum_maturity: null,
    minimum_maturity: 0,
    page: 0,
    page_size: 24,
    sort: "score",
    streams: [],
    standards: [],
    strategy: "SIMPLE_LEXICAL",
    topics: [],
    visibility_parameters: null,
    raw: false,
    viewmodel_type: "card",
    visibility_key: null,
  },
  opensearch_query: {
    query: {
      bool: {
        filter: [
          {
            terms: {
              content_type: [
                "ARTICLE",
                "BUNDLE",
                "INTERACTIVE_VIDEO",
                "WORKSHEET",
              ],
            },
          },
        ],
      },
    },
    size: 24,
    from: 0,
  },
  results: [
    {
      generated_date: "2025-02-26T17:39:08.205Z",
      id: "ck9nooe2h02yq0iqjyh59tkuk",
      description:
        "The popularity and downfall of Quakerism in the United States.",
      display_date: "2020-02-04",
      images: [
        {
          generated_date: "2025-02-26T17:39:08.205Z",
          id: "ckpx2b7w402zwp1mzfzmtzf5i",
          alt_text: "A group of people in a room.",
          auto: "format,compress",
          credit: "Courtesy of Wikimedia.",
          crop: "faces,edges",
          fit: "crop",
          fp_x: 0.5,
          fp_y: 0.5,
          fp_z: 1.0,
          height: 946,
          url: "https://newsela.imgix.net/article_media/2016/09/gl-history-origins-pennsylvania-quakers-f6606153.jpg",
          width: 1366,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/article_media/2016/09/gl-history-origins-pennsylvania-quakers-f6606153.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=946&w=1366",
        },
      ],
      metadata: {
        article_type: "ARTICLE_INFORMATION",
        content_type: "ARTICLE",
        date_lite_product_grant_expires: null,
        grade_levels: [3, 5, 7, 9, 12],
        has_formative: false,
        has_power_words: false,
        lexile_levels: [790, 1450, 540, 1030, 1190, 1290, 1190, 1030, 570, 790],
        languages: ["LANG_EN", "LANG_ES"],
        maturity_range: [6, 12],
        reading_skills: [
          "What the Text Says",
          "Connecting People, Events, Ideas",
        ],
        article_header_fragment: null,
      },
      title: "Settlement: The Origins and Legacy of the Pennsylvania Quakers",
      url: "/view/ck9nooe2h02yq0iqjyh59tkuk/",
      viewmodel_type: "card",
    },
    {
      generated_date: "2025-02-26T20:46:12.376Z",
      id: "cl48qabwf051w08olgibgcae8",
      description:
        "Did you know that before the Constitution, there was another governing system in the US?  The Articles of Confederation.",
      display_date: "2024-07-26",
      images: [
        {
          generated_date: "2025-02-26T20:46:12.376Z",
          id: null,
          alt_text: null,
          auto: "format,compress",
          credit: null,
          crop: null,
          fit: null,
          fp_x: null,
          fp_y: null,
          fp_z: null,
          height: 518,
          url: "https://newsela.imgix.net/published/prod/43248724/25747/a0b53bb1-7fdb-4f25-bf95-62e2262b20a2/369f3064-6d62-4b1c-8aa9-7c59018c0228/assets/images/f777988f-7e38-401b-96fc-5bd0536cd197.jpg",
          width: 920,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/published/prod/43248724/25747/a0b53bb1-7fdb-4f25-bf95-62e2262b20a2/369f3064-6d62-4b1c-8aa9-7c59018c0228/assets/images/f777988f-7e38-401b-96fc-5bd0536cd197.jpg?auto=format%2Ccompress&h=518&w=920",
        },
      ],
      metadata: {
        content_type: "INTERACTIVE_VIDEO",
        duration_in_seconds: 110,
      },
      title: "The Articles of Confederation",
      url: "/view/cl48qabwf051w08olgibgcae8/",
      viewmodel_type: "card",
    },
    {
      generated_date: "2025-02-26T20:45:42.981Z",
      id: "ck1045d1v9ws25mp7eplnnjhv",
      description:
        "Browse Elementary Novel & Book Studies for books most relevant to elementary readers.\n\nDon't see the novel or book you are teaching? Complete this survey to request new novel studies and share feedback with Newsela’s Content team!",
      display_date: "2025-01-27",
      images: [
        {
          generated_date: "2025-02-26T20:45:42.981Z",
          id: "ckpx21xla00pcp1mzu2ufhwg2",
          alt_text: "A man jumping in the air over a body of water.",
          auto: "format,compress",
          credit: "Alan Berner/Seattle Times/MCT",
          crop: "faces,edges",
          fit: "crop",
          fp_x: 0.5,
          fp_y: 0.5,
          fp_z: 1.0,
          height: 1924,
          url: "https://newsela.imgix.net/article_media/2014/08/underwaterrobot-teens-707c132a.jpg",
          width: 3000,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/article_media/2014/08/underwaterrobot-teens-707c132a.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=1924&w=3000",
        },
        {
          generated_date: "2025-02-26T20:45:42.981Z",
          id: "ckpx207xc006bp1mzq6c1yjp1",
          alt_text: "A group of people walking down the street.",
          auto: "format,compress",
          credit: "AP Photo/Khalil Senosi",
          crop: "faces,edges",
          fit: "crop",
          fp_x: 0.5,
          fp_y: 0.5,
          fp_z: 1.0,
          height: 2476,
          url: "https://newsela.imgix.net/article_media/2013/09/kenya-attack-acc0ad76.jpg",
          width: 3300,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/article_media/2013/09/kenya-attack-acc0ad76.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=2476&w=3300",
        },
        {
          generated_date: "2025-02-26T20:45:42.981Z",
          id: "ckpx2tghc07yjp1mzgquwwjwm",
          alt_text:
            "Illustration of the digestive system showing the liver, stomach and intestines",
          auto: "format,compress",
          credit: null,
          crop: "faces,edges",
          fit: "crop",
          fp_x: 0.5,
          fp_y: 0.5,
          fp_z: 1.0,
          height: 1000,
          url: "https://newsela.imgix.net/article_media/2019/07/lib-digestive-system-overview-85847749.jpg",
          width: 1500,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/article_media/2019/07/lib-digestive-system-overview-85847749.jpg?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=1000&w=1500",
        },
        {
          generated_date: "2025-02-26T20:45:42.981Z",
          id: "clw82kq4w00173b6fyv2nandp",
          alt_text:
            "A scuba diver holding a large red spiky urchin. The spikes are long and thick but not sharp.",
          auto: "format,compress",
          credit: "Photo: Cavan Images/Alamy",
          crop: "faces,edges",
          fit: "crop",
          fp_x: 0.5,
          fp_y: 0.5,
          fp_z: 1.0,
          height: 2700,
          url: "https://newsela.imgix.net/alexandria/image/2024/05/15/2t5mjwn-header-5s39o10973.png",
          width: 4800,
          viewmodel_type: "image",
          formatted_url:
            "https://newsela.imgix.net/alexandria/image/2024/05/15/2t5mjwn-header-5s39o10973.png?auto=format%2Ccompress&crop=faces%2Cedges&fit=crop&fp-x=0.5&fp-y=0.5&fp-z=1.0&h=2700&w=4800",
        },
      ],
      metadata: {
        asset_count_by_content_type: {},
        content_type: "BUNDLE",
        label: "Collection",
      },
      title: "Elementary Novel & Book Studies",
      url: "/content/ck1045d1v9ws25mp7eplnnjhv/",
      viewmodel_type: "card",
    },
  ],
  total_result_count: 45,
  possible_more_results: true,
  body_context: {
    prompt: "Dogs in my neighborhood for second graders",
    chips: [
      {
        label: "Articles",
        type: "content_types",
        value: "ARTICLE",
        score: 1.0,
        selected: true,
      },
      {
        label: "Dogs",
        type: "topics",
        value: "clsm7xcf0001xqt903xb6739n",
        score: 0.9,
        selected: true,
      },
      {
        label: "Pets",
        type: "topics",
        value: "clsm7xcf00028qt90r73duub7",
        score: 0.7,
        selected: true,
      },
      {
        label: "Animals",
        type: "topics",
        value: "clsm7xcf0001uqt90g4e2n9z3",
        score: 0.6,
        selected: false,
      },
      {
        label: "2nd",
        type: "grade_levels",
        value: "2",
        score: 0.95,
        selected: true,
      },
    ],
  },
  seti_failed: false,
};
